import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import {
  onboardingQuestionsExceptions,
  BEGIN_AGREEMENT
} from 'utils/constants/OnboardingQuestions';
import QuestionMessage from './QuestionMessage';
import AnswerMessage from './AnswerMessage';
import './OnboardingQuestions.scss';

class OnboardingQuestionsContainer extends React.Component {

  renderThumb = () => {
    const thumbStyle = {
      'backgroundColor': 'rgb(34, 34, 34)',
      'border-radius': '5px'
    };
    return (
        <div style={{ ...thumbStyle }}/>
    );
  }

  render() {
    let {
      onboardingQuestions,
      onboardingResponses,
      history,
      clientId
    } = this.props;


    return (
      <div className="onboarding-messages">
        <Scrollbars renderThumbHorizontal={this.renderThumb} renderThumbVertical={this.renderThumb}>
          <ul className="message-list">
          {onboardingQuestions && onboardingQuestions.length &&
            onboardingQuestions.map(question => {
              if(!onboardingQuestionsExceptions.includes(question.key)) {
                return (
                  <div className="messages-container">
                    <QuestionMessage
                      question={question}
                      answer={onboardingResponses[question.key]}
                      history={history}
                      clientId={clientId}
                    />

                    {
                      BEGIN_AGREEMENT !== question.key && (
                        <AnswerMessage
                          question={question}
                          answer={onboardingResponses[question.key]}
                        />
                      )
                    }
                  </div>
                )
              } else { return null; }
            })
          }
          </ul>
        </Scrollbars>
      </div>
    );
  }
}

export default OnboardingQuestionsContainer;
